import { Component } from '@angular/core';

@Component({
	templateUrl: './accessdenied-page.component.html',
})
export class AccessDeniedPageComponent {}
